import { 
  Vector3, 
  Box3, 
  BoxGeometry,
  BufferGeometry, 
  BufferAttribute,
  MeshBasicMaterial, 
  Mesh,
  DoubleSide
} from "three";
import { CSG } from "three-csg-ts"; // 或者 "three-bvh-csg"
import { mergeGeometries } from "three/examples/jsm/utils/BufferGeometryUtils.js";

/**
 * 投影工具类
 * 用于将模型投影到地形上并挖洞
 */
export class ProjectionTool {
  constructor(manager) {
    this.manager = manager;
    this.projectionHeight = 100; // 投影体高度
    this.previewMesh = null; // 预览网格
  }

  /**
   * 创建符合模型形状的投影体
   * @param {Object3D} model - 要投影的模型
   * @returns {Mesh} - 投影体网格
   */
  createShapedProjection(model) {
    /*// 收集模型中所有网格的几何体
    const geometries = [];
    
    model.traverse(child => {
      if (child.isMesh && child.geometry) {
        // 克隆几何体并应用世界变换
        const clonedGeometry = child.geometry.clone();
        clonedGeometry.applyMatrix4(child.matrixWorld);
        geometries.push(clonedGeometry);
      }
    });
    
    // 如果没有找到几何体，返回null
    if (geometries.length === 0) return null;
    
    // 合并所有几何体
    const mergedGeometry = mergeGeometries(geometries);
    
    // 获取合并后几何体的边界
    const box = new Box3().setFromBufferAttribute(mergedGeometry.attributes.position);
    const modelBottom = box.min.y;
    
    // 创建投影体（将模型几何体向下延伸）
    const positions = mergedGeometry.attributes.position.array;
    const vertexCount = positions.length / 3;
    
    // 创建新的几何体，包含原始顶点和向下延伸的顶点
    const projectionGeometry = new BufferGeometry();
    const newPositions = new Float32Array(vertexCount * 2 * 3); // 原始顶点 + 向下延伸的顶点
    
    // 复制原始顶点
    for (let i = 0; i < positions.length; i++) {
      newPositions[i] = positions[i];
    }
    
    // 创建向下延伸的顶点
    for (let i = 0; i < vertexCount; i++) {
      const baseIndex = i * 3;
      const newIndex = (vertexCount + i) * 3;
      
      newPositions[newIndex] = positions[baseIndex]; // x
      newPositions[newIndex + 1] = modelBottom - this.projectionHeight; // y (向下延伸)
      newPositions[newIndex + 2] = positions[baseIndex + 2]; // z
    }
    
    // 设置几何体属性
    projectionGeometry.setAttribute('position', new BufferAttribute(newPositions, 3));
    
    // 创建索引（连接原始顶点和延伸顶点形成侧面）
    const indices = [];
    
    // 假设原始几何体是三角形网格
    const originalIndices = mergedGeometry.index ? 
      mergedGeometry.index.array : 
      Array.from({ length: vertexCount }, (_, i) => i);
    
    // 复制原始三角形
    for (let i = 0; i < originalIndices.length; i += 3) {
      const a = originalIndices[i];
      const b = originalIndices[i + 1];
      const c = originalIndices[i + 2];
      
      indices.push(a, b, c); // 原始三角形
      
      // 底部三角形（反向）
      indices.push(vertexCount + c, vertexCount + b, vertexCount + a);
    }
    
    // 创建侧面三角形
    for (let i = 0; i < originalIndices.length; i += 3) {
      for (let j = 0; j < 3; j++) {
        const a = originalIndices[i + j];
        const b = originalIndices[i + (j + 1) % 3];
        const c = vertexCount + a;
        const d = vertexCount + b;
        
        // 每个边创建两个三角形
        indices.push(a, b, c);
        indices.push(b, d, c);
      }
    }
    
    projectionGeometry.setIndex(indices);
    projectionGeometry.computeVertexNormals();
    
    // 创建投影体网格
    const projectionMaterial = new MeshBasicMaterial({
      color: 0x0088ff,
      transparent: true,
      opacity: 1,
      side: DoubleSide
    });
    
    return new Mesh(projectionGeometry, projectionMaterial);*/

    console.log("开始创建投影体", model);
  
    // 获取模型边界
    const box = new Box3().setFromObject(model);
    const size = box.getSize(new Vector3());
    const center = box.getCenter(new Vector3());
    const modelBottom = box.min.y;
    
    console.log("模型边界:", box);
    console.log("模型尺寸:", size);
    console.log("模型中心:", center);
    
    // 先使用简单的几何体测试
    const geometry = new BoxGeometry(size.x, this.projectionHeight, size.z);
    const material = new MeshBasicMaterial({
        color: 0x0088ff,
        transparent: true,
        opacity: 1,
        side: DoubleSide
    });
    
    const mesh = new Mesh(geometry, material);
    mesh.position.set(center.x, modelBottom - this.projectionHeight/2, center.z);
    
    console.log("创建的简单投影体:", mesh);
    
    return mesh;
  }

  /**
   * 从地形中挖出模型投影的洞
   * @param {Mesh} terrain - 地形网格
   * @param {Object3D} model - 要投影的模型
   * @returns {Mesh} - 处理后的地形网格
   */
  cutHoleInTerrain(terrain, model) {
    if (!terrain || !model) return null;
    
    // 创建投影体
    const projectionMesh = this.createShapedProjection(model);
    if (!projectionMesh) return terrain;
    
    // 执行CSG操作
    const terrainCSG = CSG.fromMesh(terrain);
    const projectionCSG = CSG.fromMesh(projectionMesh);
    const resultCSG = terrainCSG.subtract(projectionCSG);
    
    // 创建结果网格
    /*const resultMesh = CSG.toMesh(
      resultCSG,
      terrain.matrix,
      terrain.material.clone()
    );
    
    // 保持原始属性
    resultMesh.name = terrain.name;
    resultMesh.castShadow = terrain.castShadow;
    resultMesh.receiveShadow = terrain.receiveShadow;
    
    // 清理
    projectionMesh.geometry.dispose();
    projectionMesh.material.dispose();
    
    return resultMesh;*/
  }

  /**
   * 创建投影预览
   * @param {Object3D} model - 要投影的模型
   * @returns {Mesh} - 预览网格
   */
  createProjectionPreview(model) {
    // 移除旧的预览
    this.removePreview();
    
    // 创建新的预览
    this.previewMesh = this.createShapedProjection(model);
    
    if (this.previewMesh) {
      // 添加到场景
      this.manager.sceneManager.scene.add(this.previewMesh);
    }
    
    return this.previewMesh;
  }

  /**
   * 移除预览
   */
  removePreview() {
    if (this.previewMesh) {
      this.manager.sceneManager.scene.remove(this.previewMesh);
      this.previewMesh.geometry.dispose();
      this.previewMesh.material.dispose();
      this.previewMesh = null;
    }
  }

  /**
   * 设置投影高度
   * @param {number} height - 投影高度
   */
  setProjectionHeight(height) {
    if (height > 0) {
      this.projectionHeight = height;
    }
  }

  /**
   * 处理多个模型
   * @param {Mesh} terrain - 地形网格
   * @param {Array<Object3D>} models - 模型数组
   * @returns {Mesh} - 处理后的地形网格
   */
  processMultipleModels(terrain, models) {
    let currentTerrain = terrain;
    
    models.forEach(model => {
      if (model.visible && !model._delete) {
        currentTerrain = this.cutHoleInTerrain(currentTerrain, model);
      }
    });
    
    return currentTerrain;
  }
}
